<template>
  <div>

    <div class="mt-4" v-if="days && days.length && !loading">
      <div v-for="session in days" :key="session.id">
        <SessionLine :logged-in="loggedIn" class="mb-6" :session="session"></SessionLine>
      </div>
    </div>
    <div class="mt-4 flex items-center justify-center" v-else-if="loading">
      <Spinner class="mt-10"></Spinner>
    </div>
    <div class="mt-4 text-center pt-4." v-else>
      <p>No classes found.</p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, defineProps } from 'vue';

import SessionLine from './SessionLine.vue';
import Spinner from './Spinner.vue';

const props = defineProps({
  loggedIn: {
    default: false,
    type: Boolean
  },
  teacherId: {
    default: 0,
    type: Number
  }
});

const days = ref([]);

const date = ref(new Date());

const loading = ref(false);

const yogaTypes = ref([]);
const currentYogaType = ref(0);
const currentTeacher = ref(0);
const teachers = ref([]);
const startDate = ref(new Date().toISOString().split('T')[0]);

onMounted(() => {

  currentTeacher.value = props.teacherId;

  // Initialize date and selectedDate based on startDate
  date.value = new Date(startDate.value);

  console.log(currentTeacher.value);
  fetchClasses();
});

const fetchClasses = () => {
  loading.value = true;
  fetch(`/api/sessions/all?limit=3&fromNow=1&hidePrivate=1`, {
    method: 'get',
    headers: {
      'Content-type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        console.log(response);
        days.value = response.sessions;
        yogaTypes.value = response.yogaTypes;
        teachers.value = response.teachers;
        loading.value = false;

      });
}


</script>